export default __webpack_public_path__ + "static/media/4.59b00fcf.png";